import { gql } from "graphql-request";

import { TrashEntityType } from "@ark/shared";

// Authored with `gql` (not the codegen `graphql()` helper) plus explicit
// response types so the trash feature type-checks ahead of the next
// `pnpm codegen` run, which will register these operations for real.

export enum TrashScope {
  MINE = "MINE",
  WORKSPACE = "WORKSPACE",
  TEAM = "TEAM",
}

export interface TrashItemResponse {
  id: string;
  entityType: TrashEntityType;
  label: string;
  deletedAt: string;
  deletedByName: string | null;
  canRestore?: boolean | null;
  canPermanentlyDelete?: boolean | null;
}

export interface TrashListResponse {
  // Includes one lookahead row beyond TRASH_MAX_PAGE_SIZE to determine whether another page exists.
  trashList: TrashItemResponse[];
}

export interface RestoreEntitiesResponse {
  restoreEntities: number;
}

export interface PermanentlyDeleteEntitiesResponse {
  permanentlyDeleteEntities: number;
}

export const trashListQueryDocument = gql`
  query TrashList($input: ListTrashInput!) {
    trashList(listTrashInput: $input) {
      id
      entityType
      label
      deletedAt
      deletedByName
      canRestore
      canPermanentlyDelete
    }
  }
`;

export const restoreEntitiesMutationDocument = gql`
  mutation RestoreEntities($input: MutateTrashInput!) {
    restoreEntities(restoreEntitiesInput: $input)
  }
`;

export const permanentlyDeleteEntitiesMutationDocument = gql`
  mutation PermanentlyDeleteEntities($input: MutateTrashInput!) {
    permanentlyDeleteEntities(permanentlyDeleteEntitiesInput: $input)
  }
`;
